import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react";
import ConsultantForm from "./ConsultantForm";
import { useTranslation } from "react-i18next";
import {
  MODAL_CONTENT_SX,
  MODAL_HEADER_SX,
} from "../../../components/Portal/portalModalChrome";

const ConsultantFormModal = ({ isOpen, onClose, initialData, onSuccess }) => {
  const { t } = useTranslation("portal");
  const isEdit = Boolean(initialData?.id);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl">
      <ModalOverlay bg="rgba(11,31,58,.45)" />
      <ModalContent sx={MODAL_CONTENT_SX}>
        <ModalHeader sx={MODAL_HEADER_SX}>
          {isEdit
            ? t("pilotConsultants.form.modalTitleEdit")
            : t("pilotConsultants.form.modalTitleCreate")}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody bg="portal.bg" py="14px">
          <ConsultantForm
            initialData={initialData}
            onSuccess={onSuccess}
            onCancel={onClose}
            isEdit={isEdit}
            showBackButton={false}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ConsultantFormModal;
